// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--Ytn65","label":"dd31006766--label--dP0g0","buttons":"dd31006766--buttons--nVqkM","mobile":"dd31006766--mobile--nhTTw"};